'use client'

import { ButtonLink, InputCurrency, PaymentType } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row, Skeleton, Typography } from '@repo/ui/components'
import { useUserPortfolio } from '@repo/services'
import { useMemo } from 'react'

export const BalanceCTA = ({ origin }: { origin: 'layout' | 'container' }) => {
  const { t } = useTranslate()

  const { data: { data: { accounts = [] } = {} } = {}, isLoading } =
    useUserPortfolio()

  const currency = 'IRR'

  const account = useMemo(() => {
    return accounts?.find((account) => account.currency === currency)
  }, [accounts, currency])

  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''}  justify-between h-fit gap-md p-xs bg-neutral-surface-light`}
    >
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        aria-label='Back to Wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' className='mt-xs' />}
      />
      <Typography size='md' weight='bold' className='flex-1'>
        {currency === 'IRR'
          ? t('walletPage_toman_balance')
          : t('walletPage_malek_balance')}
      </Typography>
      {isLoading ? (
        <Skeleton className='w-36 h-md' />
      ) : (
        <PaymentType
          value={account?.availableBalance}
          numberSize='md'
          size='xs'
          inputCurrency={currency as InputCurrency}
        />
      )}
    </Row>
  )
}
